<script setup lang="ts">
import { defineProps, defineEmits, watch } from 'vue';

import FileUpload from 'primevue/fileupload';

import { useJSONUpload } from '../composables/useJSONUpload';

defineProps<{
  chooseLabel: string;
  isLoading: boolean;
}>();

const emit = defineEmits<{
  (e: 'update', json: object): void;
}>();
const { handleFileUpload, jsonData } = useJSONUpload();

const onUpload = (event: { files: File[] }) => {
  const file = event.files[0];

  handleFileUpload(file);
};

watch(jsonData, () => {
  if (!jsonData.value) return;

  emit('update', jsonData.value);
});
</script>

<template>
  <FileUpload
    class="[&__.p-button-label]:font-normal"
    mode="basic"
    accept=".json"
    :maxFileSize="1000000"
    @select="onUpload"
    :chooseLabel="chooseLabel"
    :chooseButtonProps="{
      size: 'small',
      loading: isLoading,
    }"
  >
    <template #filelabel>{{ null }}</template>
  </FileUpload>
</template>
